import { render, staticRenderFns } from "./CookieManager.vue?vue&type=template&id=1d85e9d0&"
import script from "./CookieManager.vue?vue&type=script&lang=js&"
export * from "./CookieManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports